import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h5zsy5juqx: FaireBrandEntity = {
  token: "b_h5zsy5juqx",
  type: "brand",
  name: "Alaska Beauty Peony Cooperative",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc7bde44f3efe0cbfe505c91d1e0105f01010fba901ce74df7c1277d222e7b59.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bcbe8352f19168b4e0e432c12a120e67f8a8e4e4137cea6301fd313c0e1187ff.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fc7bde44f3efe0cbfe505c91d1e0105f01010fba901ce74df7c1277d222e7b59.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bcbe8352f19168b4e0e432c12a120e67f8a8e4e4137cea6301fd313c0e1187ff.jpeg",
  location: "Homer, AK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: false,
  description:
    "We are passionate about conscientiously growing quality peonies under Alaska’s midnight sun.\n\nOur collective of farmers are part of a growing movement to provide premium 'slow flowers' to you. \n\nFarming is a family affair for our co-op, with multiple generations coming together to help handpick the tidal wave of more than 40 varieties of peonies that roll in during harvest time. With farms distributed over a range of elevations, we have the longest harvest period in Alaska.\n\nOur growers are a cast of characters, from original homesteading families to recent Alaskan transplants. No matter how long we have been here or where we come from, we are enthusiastic about sustainable farming practices to cultivate peonies along the coast and in the hills above Kachemak Bay in Homer, Alaska.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:15.679Z",
    importedBy: "entity-db-cli",
  },
};
